import { Host, h } from '@stencil/core';
import classNames from '../../../utils/classnames.utils';
// import mockData from './_mock/prompt.json';
export class AibaPrompt {
  constructor() {
    this.onCloseClick = () => {
      this.displayprompt = false;
    };
    this.onClosepromptWithTimeout = () => {
      if (this.timeout) {
        if (typeof this.timeout === 'number' || typeof this.timeout === 'string') {
          if (!isNaN(Number(this.timeout))) {
            setTimeout(() => {
              this.onCloseClick();
            }, Number(this.timeout));
          }
        }
        else {
          setTimeout(() => {
            this.onCloseClick();
          }, 0);
        }
      }
    };
    this.icon = undefined;
    this.data = undefined;
    this.heading = undefined;
    this.message = undefined;
    this.iconAltText = undefined;
    this.borderRadius = undefined;
    this.closeIcon = undefined;
    this.closeText = undefined;
    this.displayprompt = true;
    this.styles = undefined;
    this.timeout = undefined;
    this.classes = undefined;
  }
  render() {
    if (typeof this.data === 'string') {
      this.data = JSON.parse(this.data);
    }
    this.timeout && this.onClosepromptWithTimeout();
    return (h(Host, null, this.styles && h("style", null, this.styles), this.displayprompt && (h("div", { class: `${this.getCssClassMap()}` }, this.data &&
      this.data.elements.map((element) => {
        var _a, _b;
        if (element.name === 'aiba-icon' || this.icon) {
          return h("aiba-icon", { url: this.icon ? this.icon : element.data.src, altText: this.iconAltText ? this.iconAltText : element.data.altText });
        }
        if (element.name === 'grid-item-message') {
          return (h("div", { class: "prompt_content-wrapper" }, (_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.elements.map((item) => {
            if (item.name === 'aiba-label') {
              return h("aiba-label", Object.assign({}, item['data']));
            }
          })));
        }
        if (element.name === 'aiba-close-button') {
          return (h("div", { onClick: this.onCloseClick, class: "closeIconBtn" }, h("aiba-close-button", { icon: this.closeIcon ? this.closeIcon : (_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.icon, text: this.closeText ? this.closeText : element.data.text })));
        }
      })))));
  }
  getCssClassMap() {
    return classNames('prompt', this.borderRadius && `prompt--border-radius`, this.classes && `${this.classes}`);
  }
  static get is() { return "aiba-prompt"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-prompt.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-prompt.css"]
    };
  }
  static get properties() {
    return {
      "icon": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "icon",
        "reflect": false
      },
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "heading": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "heading",
        "reflect": false
      },
      "message": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "message",
        "reflect": false
      },
      "iconAltText": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "icon-alt-text",
        "reflect": false
      },
      "borderRadius": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "border-radius",
        "reflect": false
      },
      "closeIcon": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "close-icon",
        "reflect": false
      },
      "closeText": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "close-text",
        "reflect": false
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "timeout": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "timeout",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "displayprompt": {}
    };
  }
}
//# sourceMappingURL=aiba-prompt.js.map
